var swiper2 = new Swiper(".mySwiper", {
  spaceBetween: 0,
  slidesPerView: "auto",
  loop: true, // Infinite loop for continuous movement
  loopedSlides: 8, // Number of slides to loop
  autoplay: {
    delay: 0, // Immediate transition between slides
    disableOnInteraction: false, // Disable autoplay pausing on user interaction
    pauseOnMouseEnter: true, // Pause autoplay on mouse hover for interaction
  },
  speed: 6000, // Fast transition speed for a dynamic feel
  centeredSlides: true, // Center slides for smooth visual effect
  allowTouchMove: false, // Disable manual touch/mouse drag interactions
  slideToClickedSlide: false, // Prevent navigation by clicking on a slide
  breakpoints: {
    640: {
      slidesPerView: 2,
      spaceBetween: 0,
    },
    768: {
      slidesPerView: 4,
      spaceBetween: 0,
    },
    1024: {
      slidesPerView: 6,
      spaceBetween: 0,
    },
    1200: {
      slidesPerView: 6,
      spaceBetween: 0,
    },
  },
});

var swiper = new Swiper(".features-swiper", {
  slidesPerView: 1,
  spaceBetween: 20,
  pagination: {
    el: ".swiper-pagination",
    hide: false,
  },
  breakpoints: {
    768: {
      slidesPerView: 4,
      pagination: {
        el: ".swiper-pagination",
      },
    },
  },
});

var swiper = new Swiper(".health-benifits-swiper", {
  slidesPerView: 1,
  spaceBetween: 20,
  loop: true,
  pagination: {
    el: ".swiper-pagination",
    hide: false,
  },
  breakpoints: {
    340: {
      slidesPerView: 1.2,
      centeredSlides: true,
      loop: true,
      pagination: {
        el: ".swiper-pagination",
      },
    },
    768: {
      slidesPerView: 4,
      pagination: {
        el: ".swiper-pagination",
      },
    },
  },
});



var productSwiper = new Swiper(".features-product-swiper", {
  slidesPerView: 1.1,
  spaceBetween: 20,
  loop: true,
  pagination: {
    el: ".swiper-pagination",
    hide: false,
  },
  breakpoints: {
    768: {
      slidesPerView: 3.05,
      pagination: {
        el: ".swiper-pagination",
      },
    },
  },
});

var reviewSwiper = new Swiper(".customer-reviews-swiper", {
  slidesPerView: 1.3,
  spaceBetween: 20,
  loop: true,
  pagination: {
    el: ".swiper-pagination",
    hide: false,
  },
  breakpoints: {
    768: {
      slidesPerView: 4.5,
      pagination: {
        el: ".swiper-pagination",
      },
    },
  },
});

var reviewSwiper = new Swiper(".products-swiper", {
  slidesPerView: 1.1,
  spaceBetween: 20,
  loop: true,
  pagination: {
    el: ".swiper-pagination",
    hide: false,
  },
  breakpoints: {
    768: {
      slidesPerView: 2,
      pagination: {
        el: ".swiper-pagination",
      },
    },
  },
});

var swiperTicker = new Swiper(".swiperTicker", {
  spaceBetween: 60,
  slidesPerView: "auto",
  loop: true, // Infinite loop for continuous movement
  loopedSlides: 1, // Number of slides to loop
  autoplay: {
    delay: 0, // Immediate transition between slides
    disableOnInteraction: false, // Disable autoplay pausing on user interaction
    pauseOnMouseEnter: true, // Pause autoplay on mouse hover for interaction
  },
  speed: 6000, // Fast transition speed for a dynamic feel
  centeredSlides: true, // Center slides for smooth visual effect
  allowTouchMove: false, // Disable manual touch/mouse drag interactions
  slideToClickedSlide: false, // Prevent navigation by clicking on a slide
  breakpoints: {
    640: {
      slidesPerView: 2,
      spaceBetween: 30,
    },
    768: {
      slidesPerView: 3,
      spaceBetween: 50,
    },
    1024: {
      slidesPerView: 5,
      spaceBetween: 80,
    },
    1200: {
      slidesPerView: 5,
      spaceBetween: 80,
    },
  },
});


$(document).ready(function () {
  $(".inner-accordion-item .inner-accordion-title").append(
    "<i class='fa fa-angle-down' aria-hidden='true'></i>"
  ),
    $(".inner-accordion-item .inner-accordion-title").click(function () {
      $(this).children().hasClass("fa-angle-down")
        ? $(this)
            .find(".fa-angle-down")
            .removeClass("fa-angle-down")
            .addClass("fa-angle-up")
        : $(this)
            .find(".fa-angle-up")
            .removeClass("fa-angle-up")
            .addClass("fa-angle-down"),
        $(this)
          .next(".inner-accordion-item .inner-accordion-content")
          .slideToggle();
    });
});

jQuery(document).ready(function () {
  jQuery(".accordion .accordion-title, .accordion-tab-head").append(
    "<i class='fa fa-angle-down' aria-hidden='true'></i>"
  );

  jQuery(".accordion .accordion-title, .accordion-tab-head").click(function () {
    if (jQuery(this).children().hasClass("fa-angle-down")) {
      jQuery(this)
        .find(".fa-angle-down")
        .removeClass("fa-angle-down")
        .addClass("fa-angle-up");

      // Add active class when opened
      jQuery(this).parent().addClass("active");
    } else {
      jQuery(this)
        .find(".fa-angle-up")
        .removeClass("fa-angle-up")
        .addClass("fa-angle-down");

      // Remove active class when closed
      jQuery(this).parent().removeClass("active");
    }

    jQuery(this).next(".accordion .accordion-content, .accordion-tab .accordion-tab-content").slideToggle();
  });
});


$(document).ready(function() {
  // Assign some jquery elements we'll need
  var $ingredientSwiper = $(".ingredients-swiper");
  var $bottomSlide = null; // Slide whose content gets 'extracted' and placed
  // into a fixed position for animation purposes
  var $bottomSlideContent = null; // Slide content that gets passed between the
  // panning slide stack and the position 'behind'
  // the stack, needed for correct animation style

  var swiperCentred = new Swiper(".ingredients-swiper", {
    spaceBetween: 70,
    slidesPerView: 5,
    centeredSlides: true,
    loop: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev"
    },
    pagination: {
        el: ".swiper-pagination",
    },
    // Remove or adjust this setting
    loopAdditionalSlides: 1, // Adjust this number or remove it

    breakpoints: {
      320: { // for screens 320px and above
        slidesPerView: 1.4,
        centeredSlides: true,
        loop: true,
        spaceBetween: 10,
      },
      640: { // for screens 640px and above
        slidesPerView: 3,
        spaceBetween: 30,
      },
      768: { // for screens 768px and above (tablets)
        slidesPerView: 4,
        spaceBetween: 40,
      },
      1024: { // for screens 1024px and above (small laptops)
        slidesPerView: 5,
        spaceBetween: 50,
      }
    }
  });
});

$(document).ready(function() {
  // Assign some jquery elements we'll need
  var $ingredientSwiper = $(".product-reviews-swiper");
  var $bottomSlide = null; // Slide whose content gets 'extracted' and placed
  // into a fixed position for animation purposes
  var $bottomSlideContent = null; // Slide content that gets passed between the
  // panning slide stack and the position 'behind'
  // the stack, needed for correct animation style

  var swiperCentred = new Swiper(".product-reviews-swiper", {
    spaceBetween: 30,
    slidesPerView: 4,
    centeredSlides: true,
    loop: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev"
    },
    // Remove or adjust this setting
    loopAdditionalSlides: 1, // Adjust this number or remove it

    breakpoints: {
      320: { // for screens 320px and above
        slidesPerView: 1.2,
        centeredSlides: true,
        loop: true,
        spaceBetween: 10,
      },
      640: { // for screens 640px and above
        slidesPerView: 3,
        spaceBetween: 20,
      },
      768: { // for screens 768px and above (tablets)
        slidesPerView: 4,
        spaceBetween: 20,
      },
      1024: { // for screens 1024px and above (small laptops)
        slidesPerView: 3,
        spaceBetween: 20,
      }
    }
  });
});